import { Injectable } from '@angular/core';
import { ComponentBase } from '../component-base';
declare let THREE: any;
import { StageService } from './stage.service';
import { BuildFloorService } from './build-floor.service';
import { SceneUtilsService } from './scene-utils.service';
import { RailingGenerationService } from './railing/services/railing-generation.service';
import { Select3dService } from './select-3d.service';
import { EventLogService, Actions } from './eventLog';
import {AutoScaleSprite} from '../custom/AutoScaleSprite';

@Injectable()
export class CutCornerNotchService extends ComponentBase {

  constructor(
    private stage: StageService,
    private sceneUtils: SceneUtilsService,
    private railingGeneration: RailingGenerationService,
    private buildFloorSrvc: BuildFloorService,
    private select3dService: Select3dService,
    private eventLog: EventLogService
  ) {
    super();
    this.disable();
    this.select3dService.selectedTierSubject.subscribe(value => {
      if (this.isEnabled()) {
        this.removeSprites();
        this.drawSprites();
      }
    });
  }
  // spriteMap = new THREE.TextureLoader().load('../../assets/images/welcome_page/cut_angle_active.png');
  // spriteMaterial = new THREE.SpriteMaterial({ map: this.spriteMap, color: 0xffffff });
  sprites = [];
  loader = new THREE.TextureLoader();
  private raycaster: any = new THREE.Raycaster(new THREE.Vector3(), new THREE.Vector3(0, -1, 0));

  drawSprites() {
    const floor = this.select3dService.getSelectedTier();
    let counter = 0;
    const points = floor.userData.points;
    const cutPoints = [];
    const height = floor.getWorldPosition(new THREE.Vector3()).y;

    for (let i = 0; i < points.length; i++) {
      if (!points[i].superstructureType && !points[(i - 1) < 0 ? points.length - 1 : (i - 1)].superstructureType) {
        const A = i > 0 ? (i - 1) % points.length : points.length - 1;
        const B = i;
        const C = (i + 1) % points.length;
        const vector1 = new THREE.Vector2(points[A].x - points[B].x, points[A].y - points[B].y);
        const vector2 = new THREE.Vector2(points[C].x - points[B].x, points[C].y - points[B].y);
        const mult = vector1.x * vector2.x + vector1.y * vector2.y;
        if (mult <= 0.05 && mult >= -0.05 && vector1.length() > 20 && vector2.length() > 20) {
          cutPoints.push(i);
        }
      }
    }

    for (let i = 0; i < cutPoints.length; i++) {
      const spriteMap = this.loader.load('../../assets/images/sprites/notch.png');

      const spriteMaterial = new THREE.SpriteMaterial({ map: spriteMap, color: 0xffffff, depthTest: false, depthWrite: false });

      const sprite = new AutoScaleSprite(50, 50, spriteMaterial);
      sprite.userData.floorId = floor.id;
      sprite.userData.pointIndex = cutPoints[i];

      this.sprites.push(sprite);
      this.sprites[counter].position.set(points[cutPoints[i]].x, height, points[cutPoints[i]].y);
      this.stage.add(this.sprites[counter]);
      counter++;
    }
  }
  removeSprites() {
    this.stage.removeMany(this.sprites);
    this.sprites.splice(0, this.sprites.length);
  }

  disable() {
    this.removeSprites();
    super.disable();
  }

  mouseDown(e) {
    const p = this.sceneUtils.getRay(e.offsetX, e.offsetY);
    this.raycaster.ray.origin.copy(p.ray.origin);
    this.raycaster.ray.direction.copy(p.ray.direction);

    const intersection = this.raycaster.intersectObjects(this.sprites);
    if (intersection.length) {
      this.cut(intersection[0].object);
      this.removeSprites();
    }
    // if (this.camera.isIn2D()) {
    //   this.viewSwitcher.to2D();
    // } else {
    //   this.viewSwitcher.to3D();
    // }
  }

  cut(intersection) {
    const pointIndex = intersection.userData.pointIndex;
    const floor = this.stage.getFloorById(intersection.userData.floorId);
    const points = floor.userData.points;
    const oldPoints = points.map(p => ({...p}));

    const A = pointIndex > 0 ? (pointIndex - 1) % points.length : points.length - 1;
    const B = pointIndex;
    const C = (pointIndex + 1) % points.length;
    const point = new THREE.Vector2(points[B].x, points[B].y);
    const vector1 = new THREE.Vector2(points[A].x - points[B].x, points[A].y - points[B].y);
    const vector2 = new THREE.Vector2(points[C].x - points[B].x, points[C].y - points[B].y);
    const cutLength = (vector1.length() < vector2.length()) ? vector1.length() / 3 : vector2.length() / 3;
    vector1.setLength(cutLength);
    vector2.setLength(cutLength);
    const pointA = point.clone();
    const pointB = point.clone();
    const pointC = point.clone();
    pointA.add(vector1);
    pointB.add(vector2);
    pointC.add(vector1);
    pointC.add(vector2);
    points.splice(pointIndex, 1, {x : pointA.x, y : pointA.y}, {x : pointC.x, y : pointC.y}, {x : pointB.x, y : pointB.y});

    this.removeSprites();
    this.drawSprites();

    this.eventLog.dispatch(new Actions.EditFloorShapeAction(oldPoints, points, intersection.userData.floorId));
    // if (this.camera.isIn3D()) {
    //   this.orbit.enable();
    // }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/cut-corner-notch.service.ts